// Generated by ReScript, PLEASE EDIT WITH CARE

import TextJs from "../../../../../dist/libs/lead-flow/src/components/Text.js";
import FareEstimateFormCmpJs from "../../../../../dist/libs/lead-flow/src/components/FareEstimateFormCmp.js";
import GoogleMapsApiLoaderJs from "../../../../../dist/libs/lead-flow/src/components/GoogleMapsApiLoader.js";
import FareEstimateMobileFormCmpJs from "../../../../../dist/libs/lead-flow/src/components/FareEstimateMobileFormCmp.js";
import FareEstimateDesktopHorizontalCmpJs from "../../../../../dist/libs/lead-flow/src/components/FareEstimateDesktopHorizontalCmp.js";
import FareEstimatePartloadSuccessModalCmpJs from "../../../../../dist/libs/lead-flow/src/components/FareEstimatePartloadSuccessModalCmp.js";
import DesktopLocationAccuracyJs from "../../../../../dist/libs/lead-flow/src/components/desktop-location-accuracy/DesktopLocationAccuracy.js";

var make = TextJs;

var $$Text = {
  make: make
};

var make$1 = FareEstimateFormCmpJs;

var FareEstimateForm = {
  make: make$1
};

var make$2 = GoogleMapsApiLoaderJs;

var GoogleApiLoader = {
  make: make$2
};

var make$3 = FareEstimateMobileFormCmpJs;

var FareEstimateMobileForm = {
  make: make$3
};

var make$4 = DesktopLocationAccuracyJs;

var DesktopLocationAccuracy = {
  make: make$4
};

var make$5 = FareEstimateDesktopHorizontalCmpJs;

var FareEstimateDesktopHorizontalForm = {
  make: make$5
};

var make$6 = FareEstimatePartloadSuccessModalCmpJs;

var FareEstimatePartloadSuccessModal = {
  make: make$6
};

export {
  $$Text ,
  FareEstimateForm ,
  GoogleApiLoader ,
  FareEstimateMobileForm ,
  DesktopLocationAccuracy ,
  FareEstimateDesktopHorizontalForm ,
  FareEstimatePartloadSuccessModal ,
}
/* make Not a pure module */
